<template>
    <div class="py-4 container-fluid">
      <div class=" row">
        <div class="col-12">
          <orders-table
            v-for="order in orders"
            v-bind:key="order.id"
            v-bind:order="order"
          />
        </div>
      </div>

    </div>
  </template>

<script>
import axios from 'axios'
import OrdersTable from './components/OrdersTable.vue';

export default{
    name: 'Orders',
    data(){
        return{
            orders:[]
        }
    },
    components:{
        OrdersTable
    },
    mounted(){
        document.title = "My Orders | Tofali Africa"
        this.getMyOrders()
    },
    methods:{
        async getMyOrders() {
            //this.$store.commit('setIsLoading', true)
            await axios
                .get('/api/v1/orders_all/')
                .then(response => {
                    this.orders = response.data
                })
                .catch(error => {
                    console.log(error)
                })
        }
    }  
}

</script>